var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 144,
    viewBox: "0 0 91 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.6875 72L13.1875 68.5L65.6875 76L77.6875 71.5L89.6875 72V115H0.6875V72Z",
    fill: "url(#paint0_linear_2376_2676)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3693 86.2438C33.5219 89.0714 31.6804 94.6078 31.5022 97.3524C30.4923 112.904 16.941 115.939 11.9117 116.311C21.6054 117.55 30.6943 113.106 33.5219 104.22C36.7535 90.2833 47.5255 86.1765 50.8917 86.2438C48.872 87.6576 40.215 98.1603 39.5812 108.461C38.9473 118.762 25.3773 139.094 17.5659 144.009C33.3199 136.334 40.793 119.166 40.793 119.166C40.793 119.166 53.0461 90.216 58.3648 87.6576C60.3038 88.7886 62.4043 91.8991 60.5865 96.1406C48.2661 114.116 52.5749 125.764 55.9411 129.668C50.9321 121.428 56.3451 109.471 58.3648 106.845C60.3846 104.22 65.6065 100.17 66.0398 94.3228C66.2776 91.1141 64.9626 87.9269 65.03 86.2438C68.5847 81.558 67.5883 77.9628 66.6458 76.751C61.1521 83.0526 45.5057 85.7052 38.3693 86.2438Z",
    fill: "#BFA279"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4105 37.4154C9.81989 45.656 8.23103 62.1237 10.3854 69.3274C19.1105 90.656 44.4519 87.5052 56.032 83.2637C87.7017 70.4989 82.962 52.4962 76.6335 45.0905C64.6765 31.033 42.8361 34.1165 33.4105 37.4154Z",
    fill: "#714E30"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4336 64.682C27.4848 64.9513 55.465 61.7735 70.9767 46.9082C64.3788 57.1416 44.0332 75.0231 15.4336 64.682Z",
    fill: "#382315"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3747 57.4993C28.0684 43.8573 44.5627 37.7069 63.5718 39.6328C53.4051 36.0824 29.3324 34.6852 14.3747 57.4993Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5988 21.8133C70.7514 19.053 61.299 10.8258 62.2685 0C68.799 0.605924 81.4563 5.85727 75.5988 21.8133Z",
    fill: "#9AC456"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4925 11.5127C78.4404 18.299 72.3677 32.6527 68.4629 38.9813C71.0482 39.466 74.5221 43.3574 75.936 45.2425C78.1577 40.5971 78.3597 39.7892 77.1478 37.1635C76.1783 35.063 77.1478 29.6904 77.7537 27.2667C78.7232 16.764 73.9835 12.3879 71.4925 11.5127Z",
    fill: "#9AC456"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6758 8.88672C73.5133 15.9558 74.5232 14.1381 73.1094 20.1973L74.7252 21.4092C75.6946 10.9065 74.1192 14.34 69.6758 8.88672Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2376_2676",
    x1: 45.1875,
    y1: 72,
    x2: 45.1875,
    y2: 115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF7442"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeed);
export default __webpack_public_path__ + "static/media/seed.11de8d0c32a19489b94d8ad10daebaba.svg";
export { ForwardRef as ReactComponent };